import { Typography } from 'amo-styling-library'
import { useContainer } from '../../contexts/ContainerContext'
import { ContainerTable } from '../../components/containers/ContainerTable'
import type { Container } from '../../types/container'

export interface OnYardContainersViewProps {
  onContainerClick: (container: Container) => void
}

export const OnYardContainersView: React.FC<OnYardContainersViewProps> = ({
  onContainerClick,
}) => {
  const { getOnYardContainers } = useContainer()
  const onYardContainers = getOnYardContainers()

  return (
    <div>
      {/* Header Section */}
      <div className="flex justify-between items-center mb-16">
        <Typography variant="h2" className="text-gray-900">
          Op Werf Containers
        </Typography>
      </div>

      {/* Container Table */}
      <ContainerTable data={onYardContainers} onRowClick={onContainerClick} />
    </div>
  )
}
